import React from "react";
import classnames from "classnames";

import List from "../list/List";
import RelatedListItem from "./RelatedListItem";
import useRelatedArticles from "../../hooks/useRelatedArticles";
import useCustomTopics from "../../hooks/useCustomTopics";

function ActionsRelated() {
  const customTopics = useCustomTopics();
  const relatedTopics = customTopics ?? useRelatedArticles();
  const listClassNames = classnames("actions__related__list", {
      "list--text-ellipsis": !customTopics
  });

  return (
    <div className="actions__related">
      <h2 className="actions__related__heading">Related topics</h2>
      <List className={listClassNames}>
        {relatedTopics.map(({ id, slug, title, tag }) => (
          <RelatedListItem key={id || slug} to={slug} tag={tag}>
            {title}
          </RelatedListItem>
        ))}
      </List>
    </div>
  );
}

export default ActionsRelated;
